package top.wcpe.allincore.ui.runtime.ir.state

import top.wcpe.allincore.dsl.ir.expr.IrType
import top.wcpe.allincore.ui.runtime.ir.request.SuspendContinuation

/**
 * D2-b 引入的类型化 state record。
 *
 * 编译期固定的 `LinkedHashMap<String, IrType>` schema + 运行期可变 values。当前仅在状态机执行中作为
 * 「跨 await 可见的 var 帧」使用；不做类型强校验（D2-b 简化）。
 *
 * [snapshot] 提供浅拷贝快照（仅 values 层），用于把当前 record 钉在 PendingRequest 上，避免后续状态
 * 变更影响已挂起回调。
 */
class StateRecord private constructor(
    private val schema: LinkedHashMap<String, IrType>,
    private val values: LinkedHashMap<String, Any?>,
    /**
     * M4 A2 Stage 3：suspend lambda 完成回调；自然终态时由 StateMachineExecutor 触发。
     * 跨 await（PendingRequest snapshot）保留同一引用，使内层 await 链最终回流到外层调用方。
     * 普通状态机 record 此字段为 null。
     */
    var suspendContinuation: SuspendContinuation?,
) {

    /** 公开构造：仅给 schema（防御性拷贝），values 初始为空、无 continuation。 */
    constructor(schema: LinkedHashMap<String, IrType>) : this(LinkedHashMap(schema), LinkedHashMap(), null)

    /** 是否声明了 var。 */
    fun has(name: String): Boolean = schema.containsKey(name)

    fun get(name: String): Any? = values[name]

    fun set(name: String, value: Any?) {
        values[name] = value
    }

    fun getSchema(): Map<String, IrType> = schema

    fun getValues(): Map<String, Any?> = values

    /** 浅拷贝 values（schema 共享）；用于在 PendingRequest 上保留当前 var 帧快照。 */
    fun snapshot(): StateRecord = StateRecord(schema, LinkedHashMap(values), suspendContinuation)
}
